import { urlBaseDomain, urlLandingPage, urlLandingPageAccess } from "./../../api/urls";
import UserEffect from "./../effects/userEffect";
import { setUserReducer, updateUserLangReducer } from "../reducers/user";
import { setChangePassword } from "../reducers/app";

export const getAuthUser = async (dispatch) => {
  const user = await UserEffect.getAuthUser();
  dispatch(setUserReducer(user));
  if (user) {
    dispatch(setChangePassword(user.getChangePassword()));
  }

  return user;
};

export const userLogout = async (dispatch) => {
  const urlActual = window.location.href;
  let urlRedirect = urlLandingPageAccess;
  if (urlActual.length > urlBaseDomain.length) {
    urlRedirect += "&redirect_uri=" + urlActual;
  }
  const r = await UserEffect.userLogout().catch(() => {
    window.location.replace(urlRedirect);
  });
  window.location.replace(r && r.url_redirect ? r.url_redirect : urlRedirect);
  dispatch(setUserReducer(null));
  return r;
};
export const userGoLandingPage = async () => {
  window.location.replace(urlLandingPage);
  return true;
};

export const changeUserLang = async (dispatch, lang) => {
  const resp = await UserEffect.changeUserLang(lang);
  dispatch(updateUserLangReducer(lang));
  return resp;
};
export const checkCurrentPassword = async (pass) => {
  const resp = await UserEffect.checkCurrentPassword(pass);
  return resp;
};
export const changePassword = async (currentPassword, newPassword) => {
  const resp = await UserEffect.changePassword(currentPassword, newPassword);
  return resp;
};
